export const baseUrl= process.env.REACT_APP_BASE_URL;
export const baseUrl2= process.env.REACT_APP_BASE_URL_AGENCY;
export const fileUrl= process.env.REACT_APP_FILE_URL;
export const baseUrl3= process.env.REACT_APP_FILE_URL;
export const videoURL= process.env.REACT_APP_VIDEO_URL;
export const socketUrl = process.env.REACT_APP_SOCKET_URL;
